
<template>

    <div style="display:inline-block"
         :nullable="(!FinalRequired)+''"
         :title="title"
         :value="FilePath" ControlType="SingleFileUpload"
         class="SingleFileUpload">



        <a :href="$util.PrefixUrl(FilePath)" target="_blank"
           v-show="ShowLink!='false'"
           v-if="FilePath != null && FilePath != ''"
           class="FilePath"
           :title="FilePath"
           style="margin-right:10px;display:inline-block;color:black">
            <template v-if="m_ShowFileName">
                <template v-if="m_ShowPath==false">
                    {{GetFileName(FilePath)}}
                </template>
                <template v-else>
                    {{FilePath}}
                </template>

            </template>
            <template v-else>
                檢視
            </template>
        </a>
         
        <t-pictureupload :text="ButttonText"
                         v-if="m_FunctionEditable != false && FinalEnabled"
                         style="display:inline-block;"
                         :key="Key"
                         :Accept="m_Accept"
                         KeepBaseName="true"
                         multiple="false"
                         @ItemsCreate="OnUploadStart"
                         @ItemsComplete="OnUploadComplete"
                         v-model="FilePath">
        </t-pictureupload>

    </div>



</template>

<script scoped>
    import Utility from '@/Common/Utility'
    import FieldOptionService from '@/Common/FieldOptionService'
    import TControlBase from '@/Common/TControlBase';
 
    export default {
        name: "t-singlefileupload",
        data() {
            return {

                Key: 1,

                FunctionId: null,

                m_FunctionEditable:true,
                FilePath: "",
                ValidFileName: true,

                m_Accept: null,

                //m_Text: "上傳",
                ButttonText:"上傳",
                m_ShowFileName: true,
                m_ShowPath : false,
                m_Attribute: TControlBase.Attribute({
                    Options: [],
                    OptionName: "",
                    Nullable: false,
                    Enabled: true,
                    Visible: true,
                    ReadOnly: false,
                    DataType: "string"
                })
            }
        }
        ,
       
        //props: ["value", "title", "nullable", "Name", "Attribute", "Keep", "KeyName", "CheckUploadHandler", "disabled", "Text","ShowFileName","ShowPath","ShowLink","Accept"],

        props: [ "title" , "CheckUploadHandler", "Text", "ShowFileName", "ShowPath", "ShowLink", "Accept", ...TControlBase.BaseProps],

        computed: {

     
        }
        ,

        methods: {

            OnAuthChanged() {
                this.PrepareAuth();
            },

            PrepareAuth() {
                if (this.FunctionId != null) {
                    let auth;

                    auth = AuthorizeService.GetFunctionAuth(this.FunctionId);

                    if (auth != null && auth.EditAuth == 0) {
                        this.m_FunctionEditable = false;
                    }
                    else {
                        this.m_FunctionEditable = true;
                    }

 
                    this.$forceUpdate();
                }
            },
            
            GetFileName() {
                let fileName = "";
                let regex = /\//ig;
                let tokens;


                if (this.FilePath != null && this.FilePath != "") {
                    tokens = this.FilePath.split(regex);

                    fileName = tokens[tokens.length - 1];
                }

                return fileName;

            },

            OnUploadStart(toUploadItems) {
                let tokens;
                let task;
                let i;

                if (this.CheckUploadHandler != null) {
                    this.ValidFileName = this.CheckUploadHandler(toUploadItems[0].Task.FileName)
                }
                else {
                    this.ValidFileName = true;
                }

                return this.ValidFileName;
            },



            OnUploadComplete(items) {
                let filePaths = [];
                let result;
                let i;


                 if (!this.ValidFileName) {
                    return;
                }

                Utility.HideLoadingPicture();
 
                this.Key++;

                for (i = 0; i < items.length; i++) {
                    filePaths.push(items[i].PicturePath)
                }

                this.FilePath = filePaths.join(",");

                this.$emit("change", this.FilePath);
                this.$emit("input", this.FilePath);

            },


            UpdateElementByAttribute() {

            },
 
        },

 

        beforeMounted() {

        },

        mounted() {
            if (this.Keep == "true" || this.Keep == true) {
                this.LoadValue();
            }

            this.DoOnMounted();
        } ,

        created() {
            TControlBase.call(this);

            if (this.ShowPath != null) {
                if (this.ShowPath == "true" || this.ShowPath == true) {
                    this.m_ShowPath = true;
                }
                else {
                    this.m_ShowPath = false;
                }
            }
 
            this.$bus.$on("AuthChanged", this.OnAuthChanged);

            if (this.value != null) {
                this.FilePath = this.value;
            }

            if (this.Text != null) {
                this.ButttonText = this.Text;
            }

            if (this.ShowFileName == true || this.ShowFileName == "true") {
                this.m_ShowFileName = true;
            }

            if (this.Accept != null) {
                this.m_Accept = this.Accept;
            }

            this.PrepareAuth();
        },

        watch: {
            value: function (newVal, oldVal) {

                this.FilePath = newVal;
                 
            },
 
 
 

        }


    }
</script>

<style scoped>

    /deep/ .ButtonContainer.PictureUpload > span.Button {
        line-height: 36px;
        padding-top: 0px;
    }

    /deep/ .ButtonContainer.PictureUpload input.file {
        line-height: 36px;
    }
</style>
